"use client";

import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

type GradientBorderProps = {
  children: ReactNode;
  className?: string;
  glow?: boolean;
};

/** Conteneur avec bordure en dégradé (cyan/emerald) et optionnellement effet de lueur. */
export function GradientBorder({ children, className, glow }: GradientBorderProps) {
  return (
    <div
      className={cn(
        "relative rounded-2xl p-[1px]",
        "bg-gradient-to-br from-cyan-500/60 via-emerald-500/50 to-cyan-600/60",
        glow && "shadow-[0_0_40px_-10px_rgba(34,211,238,0.4)]",
        className
      )}
    >
      <div className="h-full w-full rounded-2xl bg-slate-950/95 backdrop-blur-sm">
        {children}
      </div>
    </div>
  );
}
